module.exports = __webpack_public_path__ + "static/media/notification-sell.a8d3e2b1.png";